import { http } from "./api";
import { pushDataLayer, trackPageView, trackViewContent } from "./tracking";

export const Events = {
  PAGE_VIEW: "page_view",
  PROPERTY_VIEW: "property_view",
  PROJECT_VIEW: "project_view",
  SEARCH: "search",
  FILTER_USED: "filter_used",
  SHORTLISTED: "property_shortlisted",
  COMPARED: "property_compared",
  LEAD_STARTED: "lead_started",
  LEAD_SUBMITTED: "lead_submitted",
  CALLBACK: "callback_requested",
  SCHEDULE_VISIT: "schedule_visit",
  WHATSAPP: "whatsapp_click",
  PHONE: "phone_click",
};

// Provider-agnostic event bus. Routes to GTM dataLayer + first-party sink.
export function track(event, metadata = {}) {
  try {
    if (event === Events.PAGE_VIEW) {
      trackPageView(metadata.path || window.location.pathname);
    } else if (event === Events.PROPERTY_VIEW || event === Events.PROJECT_VIEW) {
      trackViewContent(metadata.slug || "", { content_type: event });
    } else {
      pushDataLayer({ event, ...metadata });
    }
    // first-party analytics sink (fire and forget)
    http.post("/events", { event_type: event, metadata }).catch(() => {});
  } catch (e) {
    /* no-op */
  }
}
